import ReportsList from "@/components/ReportsList";

export default function ReportCandidatesPage() {
  return (
    <ReportsList
      title="Report Candidati"
      filterTypes={["candidate"]}
      emptyText="Nessun report candidato. I report vengono generati automaticamente al completamento dell'analisi."
      testIdPrefix="reports-candidates"
    />
  );
}
